<template>
    <v-dialog v-model="show" max-width="900px">
      <v-card class="privacy-modal">
        <v-card-title class="modal-title">
          TERMOS E CONDIÇÕES
          <v-btn icon @click="$emit('close')" class="close-button d-none d-md-flex">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text @scroll="onScroll">
          <div class="text">
            <br/>
          <div class="intro">
            <p><strong>Responsável:</strong> Matchcalendars</p>
            <p><strong>E-mail:</strong> suporte@matchcalendars.com</p>
          </div>
          <div class="index mt-5">
            <ol type="A">
              <li><a href="#introducao">Introdução</a></li>
              <li><a href="#objetivo">Objetivo do Serviço</a></li>
              <li><a href="#conta">Conta e registo</a></li>
              <li><a href="#utilizacao">Utilização aceitável</a></li>
              <li><a href="#privacidade">Privacidade e proteção de dados</a></li>
              <li><a href="#limitacao">Limitação de responsabilidade</a></li>
              <li><a href="#alteracoes">Alterações aos termos</a></li>
              <li><a href="#conflitos">Lei aplicável e resolução de conflitos</a></li>
              <li><a href="#contactos">Contactos</a></li>
            </ol>
          </div>
          <br/>
          <div id="introducao">
            <p><strong>A. Introdução</strong></p>
            <p>Bem-vindo ao <strong>matchcalendars.com</strong>. Este site é operado por Ana Varanda Sá Leite Guimarães, com residência em Portugal. 
                <br/>Ao aceder e utilizar este site, o utilizador concorda com os presentes Termos e Condições. Se não concordar com algum ponto, deve interromper o uso do serviço. </p>
          </div>
          <div id="objetivo">
            <p><strong>B. Objetivo do Serviço</strong></p>
            <p>O matchcalendars permite que utilizadores votem em datas com base na sua disponibilidade (verde = disponível, amarelo = possível, vermelho = indisponível) e sugere a melhor data entre todos os participantes para um evento. 
                <br/>O serviço é uma ferramenta de auxílio à organização de eventos e não garante a realização dos mesmos. </p>
          </div>
          <div id="conta">
            <p><strong>C. Conta e registo</strong></p>
            <ol>
                <li>Para utilizar certas funcionalidades do site, pode ser solicitado a fornecer um endereço de email. </li>
                <li>O utilizador é responsável pela veracidade das informações fornecidas. </li>
                <li>O serviço não se destina a menores de 16 anos sem o consentimento dos seus responsáveis legais. </li>
            </ol>
          </div>
          <div id="utilizacao">
            <p><strong>D. Utilização aceitável</strong></p>
            <ol>
                <li>O utilizador compromete-se a não utilizar o site para fins ilegais ou que violem direitos de terceiros. </li>
                <li>É proibido tentar aceder a partes do site de forma não autorizada ou interferir no seu funcionamento. </li>
            </ol>
          </div>
          <br/>
          <div id="privacidade">
            <p><strong>E. Privacidade e proteção de dados</strong></p>
            <p>O tratamento de dados pessoais é regido pela nossa Política de Privacidade, disponível <a @click="$emit('privacy-open')">aqui</a>.</p>
          </div><br/>
          <div id="limitacao">
            <p><strong>F. Limitação de responsabilidade</strong></p>
            <ol>
                <li>O site fornece sugestões de datas com base nas informações inseridas pelos utilizadores, mas não garante que essas sugestões sejam ideais ou isentas de erros. </li>
                <li>Não nos responsabilizamos por danos ou prejuízos decorrentes do uso do serviço.</li>
                <li>Podemos suspender ou encerrar o serviço a qualquer momento sem aviso prévio. </li>
            </ol>
          </div><br/>
          <div id="alteracoes">
            <p><strong>G. Alterações aos termos</strong></p>
            <p>Reservamo-nos o direito de modificar estes Termos a qualquer momento. As alterações entram em vigor a partir da sua publicação no site. </p>
          </div><br/>
          <div id="conflitos">
            <p><strong>H. Lei aplicável e resolução de conflitos</strong></p>
            <p>Estes Termos são regidos pela legislação portuguesa e europeia aplicável. Em caso de litígio, este será submetido aos tribunais da comarca do Porto, salvo disposição legal em contrário. </p>
          </div><br/>
          <div id="contactos">
            <p><strong>J. Contactos</strong></p>
            <p>Para qualquer questão relacionada com estes Termos, pode contactar-nos através de: info@matchcalendars.com </p>
          </div>
        </div>
        </v-card-text>
        <v-card-actions class="d-flex d-md-none justify-center pt-2 pb-4">
          <v-row>
            <v-col cols="12" align="center" justify="center">
              <v-btn color="error" @click="$emit('close')" block>
                Fechar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  props: {
    show:{
        typeof: Boolean, default: true
    }
  },
  watch:{
    show:{
        immediate: true,
        handler(val){
            if(val == false)
                this.$emit('close')
        }
    }
  },
  methods: {
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      document.querySelector('.privacy-content').classList.toggle('scrolled', scrollTop + clientHeight >= scrollHeight);
    }
  }
}
</script>

<style scoped>
.privacy-modal {
  border-radius: 10px;
  overflow-y: auto;
  max-height: 85vh;
}

.modal-title {
  background: linear-gradient(to right, #FAD2E1, #D8E2DC, #FAD2E1);
  color: black;
  font-size: 20px;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-button {
  color: black;
}

.privacy-content {
  padding: 20px;
  overflow-y: auto;
  max-height: 70vh;
  scrollbar-width: thin;
  scrollbar-color: #B478B5 #E9CFED;
}

.privacy-content::-webkit-scrollbar {
  width: 10px;
}

.privacy-content::-webkit-scrollbar-track {
  background: #E9CFED;
  border-radius: 5px;
}

.privacy-content::-webkit-scrollbar-thumb {
  background-color: #B478B5;
  border-radius: 5px;
}

.index ol {
  padding-left: 20px;
}

.index a {
  color: #6A1B9A;
  text-decoration: none;
}
</style>
